//@flow
//Action Type Registered
export const SELENE_INV_SUBMIT_SUCCESS='SELENE_INV_SUBMIT_SUCCESS'
export const SELENE_INV_SUBMIT_ERROR='SELENE_INV_SUBMIT_ERROR'
export const SELENE_INV_SUBMITTED_COMPLETED='SELENE_INV_SUBMITTED_COMPLETED'
export const SELENE_EDIT_VERIFY_FORM_DATA_SUCCESS='SELENE_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const SELENE_EDIT_VERIFY_FORM_DATA_ERROR='SELENE_EDIT_VERIFY_FORM_DATA_ERROR'
export const SELENE_UPDATE_FORM_ERROR='SELENE_UPDATE_FORM_ERROR'
export const REFRESH_SELENE_VENDORS_SUCCESS='REFRESH_SELENE_VENDORS_SUCCESS'
export const REFRESH_SELENE_VENDORS_ERROR='REFRESH_SELENE_VENDORS_ERROR'
export const REFRESH_SELENE_REQUESTORS_SUCCESS='REFRESH_SELENE_REQUESTORS_SUCCESS'
export const REFRESH_SELENE_REQUESTORS_ERROR='REFRESH_SELENE_REQUESTORS_ERROR'
export const REFRESH_SELENE_CACHE_VALUE='REFRESH_SELENE_CACHE_VALUE'


// WEBPACK FOOTER //
// ./src/redux/selene/actionTypes.js